var Inits = {};

  // UsersController
  Inits.Users = {
    point: function(event) {
      $('.js-show-point-apply-form-btn').on('click', function(e) {
        $('.js-point-apply-form').show();
        $('.js-point-apply-agree').hide();
        return false;
      });
    },
    setting: function(vars) {
      var iconImageUploadForm = new App.Views.IconImageUploadForm();
    },
    supporterEntry: function(vars) {
      $(window).on('beforeunload', function(e) {
        return 'まだママリサポーターズの登録申請は完了していません！';
      });
      $('.js-submit-btn').click(function(e) {
        $(window).off('beforeunload');
      });
    }
  };

  // ArticlesController
  Inits.Articles = {
    show: function(vars) {
      var $article_main, $main_wrapper, $subarea_fixed, margin_bottom, subarea_initial_top;
      $article_main  = $('.js-article-main-content');
      $main_wrapper  = $('.js-main-wrapper');
      $subarea_fixed = $('.js-subarea-fixed');
      margin_bottom  = 20;

      // subareaにfixさせるdomが無い場合は実行しない
      if ($subarea_fixed.length) {
        subarea_initial_top = $subarea_fixed.offset().top;
        $(window).on('scroll', function(event) {
          var main_subarea_diff, scroll_bottom;
          scroll_bottom     = $(window).scrollTop() + $(window).height();
          main_subarea_diff = $main_wrapper.height() - $subarea_fixed.height();

          // サブエリアの方が長い場合は何もしない
          if ($subarea_fixed.height() > $article_main.height()) {
            return;
          }

          if (scroll_bottom > $main_wrapper.offset().top + $main_wrapper.height() + margin_bottom) {
            // 記事とサブエリアの差分から上下のマージンを引いた位置で固定する
            $subarea_fixed.css({
              position: 'absolute',
              top: (main_subarea_diff + subarea_initial_top - (30 + margin_bottom)) + 'px', // 30はsubareaのmargin-topの値
              bottom: 'auto',
            });
          } else if (scroll_bottom > subarea_initial_top + $subarea_fixed.height() + margin_bottom) {
            $subarea_fixed.css({
              position: 'fixed',
              top: 'auto',
              bottom: margin_bottom + 'px',
            });
          } else {
            $subarea_fixed.css({
              position: 'static',
              top: 'auto',
              bottom: 'auto',
            });
          }
        });
      }
      // 目次アイテムは6以上の要素がある場合に「続きをみる」を表示し、以降の要素を非表示にする
      const outline_division = 5;
      const outline_len = $('.p-article-outline__list div').length
      const expandMore = () => {
        for (let i = 0; i < outline_len; i++) {
          if (i >= outline_division) {
            $('.p-article-outline__list div').eq(i).show();
          }
        }
        $('.p-article-outline__container__mask').hide();
        $('.js-article-outline-expand-label').text('折りたたむ');
        $('.material-icons').text('expand_less');
      }
      const expandLess = () => {
        for (let i = 0; i < outline_len; i++) {
          if (i >= outline_division) {
            $('.p-article-outline__list div').eq(i).hide();
          }
        }
        $('.p-article-outline__container__mask').show();
        $('.js-article-outline-expand-label').text('続きをみる');
        $('.material-icons').text('expand_more');
      }
      if (outline_len <= outline_division) {
        $('.p-article-outline__expand').hide();
        expandMore();
      } else {
        expandLess();
      }
      $('.js-article-outline-expand').change(function(){
        if($(this).prop('checked')){
          expandMore();
        } else {
          expandLess();
        }
      });
    },

    showPreview: function(vars) {
      // 目次アイテムは6以上の要素がある場合に「続きをみる」を表示し、以降の要素を非表示にする
      const outline_division = 5;
      const outline_len = $('.p-article-outline__list div').length
      const expandMore = () => {
        for (let i = 0; i < outline_len; i++) {
          if (i >= outline_division) {
            $('.p-article-outline__list div').eq(i).show();
          }
        }
        $('.p-article-outline__container__mask').hide();
        $('.js-article-outline-expand-label').text('折りたたむ');
        $('.material-icons').text('expand_less');
      }
      const expandLess = () => {
        for (let i = 0; i < outline_len; i++) {
          if (i >= outline_division) {
            $('.p-article-outline__list div').eq(i).hide();
          }
        }
        $('.p-article-outline__container__mask').show();
        $('.js-article-outline-expand-label').text('続きをみる');
        $('.material-icons').text('expand_more');
      }
      if (outline_len <= outline_division) {
        $('.p-article-outline__expand').hide();
        expandMore();
      } else {
        expandLess();
      }
      $('.js-article-outline-expand').change(function(){
        if($(this).prop('checked')){
          expandMore();
        } else {
          expandLess();
        }
      });
    },

    message: function() {
      // メッセージ送信ボックス
      new App.Views.ArticleMessageAdd().loadDraft();
      // メッセージにスタイルを当てる
      new App.Views.ArticleMessageFormatter();

      // メッセージ一覧を下までスクロールした状態で表示する
      var $messageHistory = $('.js-article-message-history');
      var height = $messageHistory.height();
      var scrollHeight = $messageHistory.prop('scrollHeight');
      var paddingBottom = parseInt($messageHistory.css('padding-bottom').replace('px', ''), 10);
      $messageHistory.scrollTop(scrollHeight - height - paddingBottom);

      // ユーザーのメモ情報を折りたたんだ状態で表示する
      var options = {
        length: 40,
        moreText: '...もっと見る',
        lessText: '閉じる'
      };
      $('.js-sprt-user-memo').each(function() {
        var obj = $(this);
        var body = obj.html();

        if(body.length > options.length) {
          // 改行文字を省略の区切りとする
          var splitLocation = body.indexOf("\n", options.length);

          if (splitLocation != -1) {
            // 省略部分の計算
            var str1 = body.substring(0, splitLocation);
            var str2 = body.substring(splitLocation, body.length - 1);
            obj.html(str1 + '<span class="truncate_more">' + str2 + '</span>');
            obj.find('.truncate_more').css("display", "none");

            // もっと読むリンクを追加
            obj.append('<div class="clearboth"><a href="#" class="truncate_more_link">' + options.moreText + '</a></div>');

            var moreLink = $('.truncate_more_link', obj);
            var moreContent = $('.truncate_more', obj);
            moreLink.on('click', function() {
              if(moreLink.text() === options.moreText) {
                moreContent.show();
                moreLink.text(options.lessText);
              } else {
                moreContent.hide();
                moreLink.text(options.moreText);
              }
              return false;
            });
          }
        }
      });

      // ステータス更新が行われているか
      var key = 'articleMessageUpdatedStatus';
      if (sessionStorage.getItem(key)) {
        sessionStorage.removeItem(key);
        $('.js-notice-status').text('お知らせ：記事のステータスが変更されました').show();
      }
    }
  };

// OffersController
Inits.Offers = {
  show: function() {
    if (App.me.is_admin) {
      new App.Views.PublishOfferLink();
    }
  }
};

module.exports = Inits;



// WEBPACK FOOTER //
// ./pc/init.js